import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {map, tap} from 'rxjs/operators';
import {Router, RouterStateSnapshot} from '@angular/router';
import {AdminUserService} from "./admin-user.service";
import {AdminSignupPayload, AdminUser, LoginCredentials, PasswordRecovery} from "../models/Authentication";
import {Observable} from "rxjs";

const ADMIN_URL = '/auth';
const LOGIN_URL = `${ADMIN_URL}/login`;
const LOGOUT_URL = `${ADMIN_URL}/logout`;
const PASSWORD_RESET_URL = `${ADMIN_URL}/reset-password`;
const PASSWORD_UPDATE_URL = `${ADMIN_URL}/update-password`;
const INVITATION_URL = `${ADMIN_URL}/invitation`;


@Injectable({
  providedIn: 'root'
})
export class AuthService {
  user: AdminUser | null = null;

  constructor(private http: HttpClient,
              private router: Router,
              private userService: AdminUserService) {
  }

  login(credentials: LoginCredentials): Observable<AdminUser> {
    return this.http.post<AdminUser>(LOGIN_URL, credentials, {withCredentials: true}).pipe(
      map((res: AdminUser) => this.processUser(res))
    );
  }

  logout(): Observable<void> {
    return this.http.post<void>(LOGOUT_URL, {}).pipe(
      tap(_ => {
        sessionStorage.removeItem('token');
        this.router.navigate(['/login']);
      })
    );
  }

  resetPassword(email: string): Observable<{message: string}> {
    return this.http.post<{message: string}>(PASSWORD_RESET_URL, {email});
  }

  updatePassword(passRecovery: PasswordRecovery): Observable<AdminUser> {
    return this.http.post<AdminUser>(PASSWORD_UPDATE_URL, passRecovery)
      .pipe(map(res => this.processUser(res)));
  }

  getInvitation(invitationToken: string): Observable<AdminUser> {
    return this.http.get<AdminUser>(`${INVITATION_URL}?invitationToken=${invitationToken}`);
  }

  signUp(signupCredentials: AdminSignupPayload) {
    return this.http.put<any>(INVITATION_URL, signupCredentials)
      .pipe(map((res: AdminUser) => this.processUser(res)));
  }

  isLoggedIn(state: RouterStateSnapshot) {
    const currToken = sessionStorage.getItem('token');
    if (currToken) {
      return true;
    }
    this.router.navigate(['/login']);
    return false;
  }

  get token(): string | null {
    return sessionStorage.getItem('token');
  }

  private processUser(res: AdminUser): AdminUser {
    this.user = res;
    if(this.user.token) {
      sessionStorage.setItem(
        'token',
        this.user.token
      );
    }
    return res;
  }
}
